import { useStaticQuery, graphql } from "gatsby";

export const useEventData = () => {
  const data = useStaticQuery(graphql`
    query {
      allWpProductCategory {
        edges {
          node {
            name
            id
          }
        }
      }
      allWpCountry {
        edges {
          node {
            name
            id
            acfFields {
              featuredImage {
                sourceUrl
                localFile {
                  childImageSharp {
                    fluid {
                      ...GatsbyImageSharpFluid_withWebp_tracedSVG
                    }
                  }
                }
                altText
              }
            }
          }
        }
      }
      allWpProduct(
        limit: 100
        filter: {
          productCategories: {
            nodes: { elemMatch: { name: { in: "Ticket" } } }
          }
        }
      ) {
        edges {
          node {
            acfFields {
              accommodation
              brochure
              days
              distance
              equipment
              eventEnd
              eventStart
              experiences
              featured
              fieldGroupName
              food
              formId
              grade
              highlights
              itinerary
              tourguides
              transport
              imageone {
                altText
                localFile {
                  childImageSharp {
                    fluid {
                      ...GatsbyImageSharpFluid_withWebp_tracedSVG
                    }
                  }
                }
                sourceUrl
              }
              imagethree {
                altText
                localFile {
                  childImageSharp {
                    fluid {
                      ...GatsbyImageSharpFluid_withWebp_tracedSVG
                    }
                  }
                }
                sourceUrl
              }
              imagetwo {
                altText
                localFile {
                  childImageSharp {
                    fluid {
                      ...GatsbyImageSharpFluid_withWebp_tracedSVG
                    }
                  }
                }
                sourceUrl
              }
            }
            featuredImage {
              node {
                sourceUrl
                localFile {
                  childImageSharp {
                    fluid {
                      ...GatsbyImageSharpFluid_withWebp_tracedSVG
                    }
                  }
                }
              }
            }
            title
            uri
            slug
            product_id
            price
            id
            productCategories {
              nodes {
                name
              }
            }
            locations {
              nodes {
                name
                slug
              }
            }
            countries {
              nodes {
                name
                acfFields {
                  featuredImage {
                    sourceUrl
                    localFile {
                      childImageSharp {
                        fluid {
                          ...GatsbyImageSharpFluid_withWebp_tracedSVG
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `);
  return data;
};
